export default {"src":"/_next/static/media/employers.4f73b2e3.svg","height":22,"width":22};